// Types for react-redux

// Global
export const SET_GLOBAL_USER = 'GLOBAL/SET_GLOBAL_USER'
export const SET_HOME_DETAILS = 'GLOBAL/SET_HOME_DETAILS'
export const SET_HOME_GROUP = 'GLOBAL/SET_HOME_GROUP'
export const SET_WINDOW_LOCATION_HISTORY = 'GLOBAL/SET_WINDOW_LOCATION_HISTORY'
export const TOGGLE_ACTIVE_FILTER = 'GLOBAL/TOGGLE_ACTIVE_FILTER'
export const RESET_FILTER = 'GLOBAL/RESET_FILTER'
export const RESET_SELECTED_FILTER = 'GLOBAL/RESET_SELECTED_FILTER'
export const SET_SORT_TYPE = 'GLOBAL/SET_SORT_TYPE'
export const TOGGLE_LOADING = 'GLOBAL/TOGGLE_LOADING'
export const SET_ABILITY = 'GLOBAL/SET_ABILITY'
export const SET_PERMISSION_TEMPLATES = 'GLOBAL/SET_PERMISSION_TEMPLATES'
export const SET_PERMISSIONS_LOADING = 'GLOBAL/SET_PERMISSIONS_LOADING'

// Data
export const SET_LOADED_LIST = 'DATA/SET_LOADED_LIST'
export const SET_LOADED_ITEM_DETAIL = 'DATA/SET_LOADED_ITEM_DETAIL'
export const SET_LOADED_LISTS = 'DATA/SET_LOADED_LISTS'
export const CLEAR_LISTS = 'DATA/CLEAR_LISTS'
export const CLEAR_ALL_LISTS = 'DATA/CLEAR_ALL_LISTS'
export const INIT_DATA_FETCH = 'DATA/INIT_DATA_FETCH'
export const SET_DATA_FETCH_RESULT = 'DATA/SET_DATA_FETCH_RESULT'
export const SET_DATA_FETCH_ERROR = 'DATA/SET_DATA_FETCH_ERROR'

// Logs
export const SET_LOGS_COUNT = 'LOGS/SET_LOGS_COUNT'
export const SET_LOGS_PAGE_NUMBER = 'LOGS/SET_LOGS_PAGE_NUMBER'
export const SET_LOGS_PAGE_SIZE = 'LOGS/SET_LOGS_PAGE_SIZE'
export const TOGGLE_LOGS_EXPORTING = 'LOGS/TOGGLE_LOGS_EXPORTING'

// Handovers
export const SET_CURRENT_HANDOVER = 'HANDOVERS/SET_CURRENT_HANDOVER'
export const SET_HANDOVER_HISTORY = 'HANDOVERS/SET_HANDOVER_HISTORY'
export const SET_HOURS_VISIBLE = 'HANDOVERS/SET_HOURS_VISIBLE'
export const SET_HISTORY_DATE_RANGE = 'HANDOVERS/SET_HISTORY_DATE_RANGE'
export const SET_LOGS_AND_NOTES = 'HANDOVERS/SET_LOGS_AND_NOTES'

// Todos
export const SET_DAILY_TODOS = 'TODOS/SET_DAILY_TODOS'
export const CLEAR_TODOS = 'TODOS/CLEAR_TODOS'
export const SET_CURRENT_DATE = 'TODOS/SET_CURRENT_DATE'
export const SET_RECURRING_TODOS = 'TODOS/SET_RECURRING_TODOS'

// Modals
export const OPEN_MODAL = 'MODALS/OPEN_MODAL'
export const CLOSE_MODAL = 'MODALS/CLOSE_MODAL'

// Forms
export const ADD_FORM = 'FORMS/ADD_FORM'
export const ADD_FORM_FILE = 'FORMS/ADD_FORM_FILE'
export const CLEAR_FIELD_VALIDATION = 'FORMS/CLEAR_FIELD_VALIDATION'
export const CLEAR_FORM = 'FORMS/CLEAR_FORM'
export const CLEAR_FORM_ARRAY_FIELD = 'FORMS/CLEAR_FORM_ARRAY_FIELD'
export const CLEAR_FORM_FIELDS = 'FORMS/CLEAR_FORM_FIELDS'
export const REMOVE_FORM = 'FORMS/REMOVE_FORM'
export const SET_FIELD_VALIDATION = 'FORMS/SET_FIELD_VALIDATION'
export const SET_FORM_FIELD = 'FORMS/SET_FORM_FIELD'
export const SET_FORM_STATE = 'FORMS/SET_FORM_STATE'
export const SET_INITIAL_FORM_FIELDS = 'FORMS/SET_INITIAL_FORM_FIELDS'
export const TOGGLE_FORM_SUBMITTING = 'FORMS/TOGGLE_FORM_SUBMITTING'
export const UPDATE_FORM_ERRORS = 'FORMS/UPDATE_FORM_ERRORS'
export const UPDATE_FORM_VALIDATION_ERRORS =
  'FORMS/UPDATE_FORM_VALIDATION_ERRORS'

// Chargebee
export const SET_CB_SUBSCRIPTION_DETAILS = 'CHARGEBEE/SET_SUBSCRIPTION_DETAILS'
export const SET_CB_CUSTOMER_DETAILS = 'CHARGEBEE/SET_CUSTOMER_DETAILS'

// Care Plans
export const SET_RESIDENT_ADLS = 'CARE_PLANS/SET_RESIDENT_ADLS'
export const SET_CARE_PLAN_SORT_TYPE = 'CARE_PLANS/SET_CARE_PLAN_SORT_TYPE'
export const SET_CARE_PLAN_HISTORY = 'CARE_PLANS/SET_CARE_PLAN_HISTORY'
export const SET_CARE_PLAN_HISTORY_DATE_RANGE =
  'CARE_PLANS/SET_CARE_PLAN_HISTORY_DATE_RANGE'
export const SET_RISK_ASSESSMENT_SORT_TYPE =
  'CARE_PLANS/SET_RISK_ASSESSMENT_SORT_TYPE'
